module.exports = __webpack_public_path__ + "56f206d5874fa65138d5cee19574ba7c.png";